import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceTypeOptionDTO  {
    _originalTypeClassName = "zERP.BO.InvoiceTypeOptionDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceTypeOptionDTO.translate = translateService;
}
this.Display = null;
this.Value = null;
this.InvoiceTypeOptionDTOKey = null;
this._key = this.InvoiceTypeOptionDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Display:any;
Value:any;
private _InvoiceTypeOptionDTOKey:any;
get InvoiceTypeOptionDTOKey(): any {
    return this._InvoiceTypeOptionDTOKey;
  }
set InvoiceTypeOptionDTOKey(value: any) {
    this._InvoiceTypeOptionDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InvoiceTypeOptionDTOKey == null || $this.InvoiceTypeOptionDTOKey == 0;
            }


}